import React from 'react';

export default function AntTableRow({ children }) {
  return (
    <tr className="ant-table-row">
      {children}
    </tr>
  );
}
